import { Component } from '@angular/core';
import {
  ListView,
  ListViewProviderDirective,
  NotificationService
} from '@ntap/core';
import { PrimeNGButtonDeleteListItemsActionComponent } from '@ntap/primeng';
import { ConfirmationService } from 'primeng/api';
import { map } from 'rxjs';

@Component({
  selector: 'app-delete-list-users',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class DeleteListUsersActionComponent extends PrimeNGButtonDeleteListItemsActionComponent {
  constructor(
    protected override listViewProvider: ListViewProviderDirective<ListView>,
    protected override confirmationService: ConfirmationService,
    protected override notificationService: NotificationService
  ) {
    super(listViewProvider, confirmationService, notificationService);
  }

  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.listViewProvider.selectedItems$.pipe(
      map((selectedUsers) => {
        return (
          selectedUsers.length === 0 ||
          selectedUsers.some((user: any) => {
            const brojPromjena = user['earhiv_user~broj_promjena_lozinke'];
            return (
              brojPromjena != undefined &&
              brojPromjena != null &&
              brojPromjena != 0
            );
          })
        );
      })
    );
  }
}
